module.exports = __webpack_public_path__ + "static/media/european-pilchard.40ccbd54.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/european-pilchard.png
// module id = 309
// module chunks = 0